document.addEventListener('DOMContentLoaded', function () {

    const cardItems = document.querySelectorAll('.about-service__cards-item');

    cardItems.forEach(cardItem => {
        const readMoreBtn = cardItem.querySelector('.read-more');
        readMoreBtn.addEventListener('click', () => {
            const svgElement = readMoreBtn.querySelector('svg');
            svgElement.classList.add('rotate');
            const computedStyle = window.getComputedStyle(cardItem);
            const maxHeight = computedStyle.getPropertyValue('max-height');
            if (maxHeight === '264px' || maxHeight==='282px') {
                cardItem.classList.add('no-height')
                const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
                svgElement.setAttribute("width", "18");
                svgElement.setAttribute("height", "18");
                svgElement.setAttribute("viewBox", "0 0 24 24");
                const polygonElement = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
                polygonElement.setAttribute("points", "12 17.414 3.293 8.707 4.707 7.293 12 14.586 19.293 7.293 20.707 8.707 12 17.414");
                svgElement.appendChild(polygonElement);
                readMoreBtn.textContent = 'Згорнути ';
                readMoreBtn.appendChild(svgElement);
                svgElement.classList.add('rotate')

            } else {
                cardItem.classList.remove('no-height')
                const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
                svgElement.setAttribute("width", "18");
                svgElement.setAttribute("height", "18");
                svgElement.setAttribute("viewBox", "0 0 24 24");
                const polygonElement = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
                polygonElement.setAttribute("points", "12 17.414 3.293 8.707 4.707 7.293 12 14.586 19.293 7.293 20.707 8.707 12 17.414");
                svgElement.appendChild(polygonElement);
                readMoreBtn.textContent = 'Переглянути більше ';
                readMoreBtn.appendChild(svgElement);
                svgElement.classList.remove('rotate')
            }
        });
    });
});
